module.exports = "/assets/data/eec352b46548074630f99182fda4fa3d-IP13.data.json";